import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Package, Eye, ChevronRight, Truck, CheckCircle, Clock, XCircle } from 'lucide-react';
import Header from './components/Header25';
import Footer from './components/Footer25';

const Orders25 = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('all');

    const statusConfig = {
        delivered: { label: 'Delivered', color: '#0D7C66', bg: '#E8F5F1', icon: CheckCircle },
        shipped: { label: 'Shipped', color: '#0D7C66', bg: '#E8F5F1', icon: Truck },
        processing: { label: 'Processing', color: '#F59E0B', bg: '#FFF8E1', icon: Clock },
        cancelled: { label: 'Cancelled', color: '#DC3545', bg: '#FEE2E5', icon: XCircle },
    };

    const orders = [
        {
            id: 'SAH-20260315-001', date: 'March 15, 2026', status: 'delivered',
            total: 9999,
            items: [
                { name: 'Classic Cotton Kurta', size: 'M', qty: 1, price: 3499, image: 'https://images.pexels.com/photos/8310281/pexels-photo-8310281.jpeg?auto=compress&cs=tinysrgb&w=200' },
                { name: 'Structured Nehru Jacket', size: 'L', qty: 1, price: 6500, image: 'https://images.pexels.com/photos/9558577/pexels-photo-9558577.jpeg?auto=compress&cs=tinysrgb&w=200' },
            ]
        },
        {
            id: 'SAH-20260312-002', date: 'March 12, 2026', status: 'shipped',
            total: 14999,
            items: [
                { name: 'Contemporary Lehenga', size: 'S', qty: 1, price: 14999, image: 'https://images.pexels.com/photos/8839887/pexels-photo-8839887.jpeg?auto=compress&cs=tinysrgb&w=200' },
            ]
        },
        {
            id: 'SAH-20260308-003', date: 'March 8, 2026', status: 'processing',
            total: 18999,
            items: [
                { name: 'Modern Sherwani Set', size: 'L', qty: 1, price: 18999, image: 'https://images.pexels.com/photos/8953474/pexels-photo-8953474.jpeg?auto=compress&cs=tinysrgb&w=200' },
            ]
        },
        {
            id: 'SAH-20260301-004', date: 'March 1, 2026', status: 'cancelled',
            total: 3200,
            items: [
                { name: 'Chanderi Silk Dupatta', size: 'Free Size', qty: 1, price: 3200, image: 'https://images.pexels.com/photos/10679171/pexels-photo-10679171.jpeg?auto=compress&cs=tinysrgb&w=200' },
            ]
        },
    ];

    const tabs = [
        { key: 'all', label: 'All Orders' },
        { key: 'processing', label: 'Processing' },
        { key: 'shipped', label: 'Shipped' },
        { key: 'delivered', label: 'Delivered' },
        { key: 'cancelled', label: 'Cancelled' },
    ];

    const filteredOrders = activeTab === 'all' ? orders : orders.filter(o => o.status === activeTab);

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&family=IBM+Plex+Sans:wght@300;400;500;600;700&display=swap');
                .sahaj-orders * { box-sizing: border-box; }
                .sahaj-orders { font-family: 'IBM Plex Sans', sans-serif; background: #FFFFFF; color: #111111; }
                .sahaj-orders-heading { font-family: 'Space Grotesk', sans-serif; }
            `}</style>
            <div className="sahaj-orders" style={{ minHeight: '100vh' }}>
                <Header />

                <div style={{ maxWidth: 1280, margin: '0 auto', padding: '100px 24px 80px' }}>
                    <h1 className="sahaj-orders-heading" style={{
                        fontSize: 40, fontWeight: 700, marginBottom: 8, letterSpacing: '-1px'
                    }}>
                        YOUR ORDERS
                    </h1>
                    <p style={{ fontSize: 15, color: '#6C757D', marginBottom: 40 }}>
                        Track and manage your orders
                    </p>

                    {/* Tabs */}
                    <div style={{ display: 'flex', gap: 0, borderBottom: '2px solid #DEE2E6', marginBottom: 40, overflowX: 'auto' }}>
                        {tabs.map(tab => (
                            <button
                                key={tab.key}
                                onClick={() => setActiveTab(tab.key)}
                                className="sahaj-orders-heading"
                                style={{
                                    padding: '14px 24px', border: 'none', background: 'none',
                                    cursor: 'pointer', fontSize: 13, fontWeight: 600,
                                    textTransform: 'uppercase', letterSpacing: '1px',
                                    color: activeTab === tab.key ? '#0D7C66' : '#6C757D',
                                    borderBottom: activeTab === tab.key ? '2px solid #0D7C66' : '2px solid transparent',
                                    marginBottom: -2, transition: 'all 0.2s', whiteSpace: 'nowrap'
                                }}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>

                    {/* Orders */}
                    {filteredOrders.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: '80px 0' }}>
                            <Package size={48} color="#DEE2E6" style={{ marginBottom: 24 }} />
                            <h2 className="sahaj-orders-heading" style={{ fontSize: 24, fontWeight: 600, marginBottom: 12 }}>
                                No orders found
                            </h2>
                            <p style={{ color: '#6C757D', marginBottom: 32 }}>You haven't placed any orders in this category</p>
                            <button
                                onClick={() => navigate('/template25/shop')}
                                style={{
                                    padding: '14px 40px', background: '#0D7C66', color: '#FFFFFF',
                                    border: 'none', fontSize: 14, fontWeight: 700, cursor: 'pointer',
                                    textTransform: 'uppercase', letterSpacing: '2px',
                                    fontFamily: 'Space Grotesk, sans-serif'
                                }}
                            >
                                Start Shopping
                            </button>
                        </div>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                            {filteredOrders.map(order => {
                                const status = statusConfig[order.status];
                                const StatusIcon = status.icon;
                                return (
                                    <div key={order.id} style={{ border: '1px solid #DEE2E6', overflow: 'hidden' }}>
                                        {/* Order Header */}
                                        <div style={{
                                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                            padding: '20px 24px', background: '#F8F9FA', borderBottom: '1px solid #DEE2E6',
                                            flexWrap: 'wrap', gap: 12
                                        }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 24, flexWrap: 'wrap' }}>
                                                <div>
                                                    <span style={{ fontSize: 11, color: '#6C757D', textTransform: 'uppercase', letterSpacing: '1px' }}>Order</span>
                                                    <p className="sahaj-orders-heading" style={{ fontSize: 16, fontWeight: 700, margin: '2px 0 0' }}>
                                                        #{order.id}
                                                    </p>
                                                </div>
                                                <div>
                                                    <span style={{ fontSize: 11, color: '#6C757D', textTransform: 'uppercase', letterSpacing: '1px' }}>Date</span>
                                                    <p style={{ fontSize: 14, margin: '2px 0 0', fontWeight: 500 }}>{order.date}</p>
                                                </div>
                                                <div>
                                                    <span style={{ fontSize: 11, color: '#6C757D', textTransform: 'uppercase', letterSpacing: '1px' }}>Total</span>
                                                    <p className="sahaj-orders-heading" style={{ fontSize: 16, fontWeight: 700, margin: '2px 0 0' }}>
                                                        ₹{order.total.toLocaleString('en-IN')}
                                                    </p>
                                                </div>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                                                <span style={{
                                                    display: 'flex', alignItems: 'center', gap: 6,
                                                    padding: '6px 16px', background: status.bg, color: status.color,
                                                    fontSize: 13, fontWeight: 600
                                                }}>
                                                    <StatusIcon size={14} />
                                                    {status.label}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Items */}
                                        <div style={{ padding: '20px 24px' }}>
                                            {order.items.map((item, idx) => (
                                                <div key={idx} style={{
                                                    display: 'flex', alignItems: 'center', gap: 16,
                                                    paddingBottom: idx < order.items.length - 1 ? 16 : 0,
                                                    marginBottom: idx < order.items.length - 1 ? 16 : 0,
                                                    borderBottom: idx < order.items.length - 1 ? '1px solid #DEE2E6' : 'none'
                                                }}>
                                                    <div style={{ width: 64, height: 64, overflow: 'hidden', flexShrink: 0 }}>
                                                        <img src={item.image} alt={item.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                    </div>
                                                    <div style={{ flex: 1 }}>
                                                        <h4 className="sahaj-orders-heading" style={{ fontSize: 15, fontWeight: 600, margin: '0 0 4px' }}>{item.name}</h4>
                                                        <p style={{ fontSize: 13, color: '#6C757D', margin: 0 }}>Size: {item.size} | Qty: {item.qty}</p>
                                                    </div>
                                                    <span className="sahaj-orders-heading" style={{ fontSize: 16, fontWeight: 700 }}>
                                                        ₹{item.price.toLocaleString('en-IN')}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>

                                        {/* Footer */}
                                        <div style={{
                                            display: 'flex', justifyContent: 'flex-end', gap: 12,
                                            padding: '16px 24px', borderTop: '1px solid #DEE2E6'
                                        }}>
                                            {order.status === 'delivered' && (
                                                <button style={{
                                                    padding: '10px 24px', border: '1px solid #DEE2E6',
                                                    background: '#FFFFFF', color: '#111111', fontSize: 13,
                                                    fontWeight: 600, cursor: 'pointer',
                                                    fontFamily: 'Space Grotesk, sans-serif',
                                                    textTransform: 'uppercase', letterSpacing: '1px'
                                                }}>
                                                    Write Review
                                                </button>
                                            )}
                                            <button
                                                style={{
                                                    padding: '10px 24px', border: 'none',
                                                    background: '#111111', color: '#FFFFFF', fontSize: 13,
                                                    fontWeight: 600, cursor: 'pointer',
                                                    display: 'flex', alignItems: 'center', gap: 8,
                                                    fontFamily: 'Space Grotesk, sans-serif',
                                                    textTransform: 'uppercase', letterSpacing: '1px'
                                                }}
                                            >
                                                <Eye size={14} />
                                                View Details
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>

                <Footer />
            </div>
        </>
    );
};

export default Orders25;
